import {cleanObject} from '../../utils/utilities';
import {events} from '../events';

export const getMySessions = (params: Record<string, unknown>) => ({
    types: [
        events.MY_SESSIONS_GET,
        events.MY_SESSIONS_SUCCESS,
        events.MY_SESSIONS_ERROR
    ],
    payload: {
        client: 'cdmMw',
        request: {
            url: params?.session_type !== 'marketdata'
                ? 'api/user-session'
                : 'api/market-data-session',
            params: cleanObject(params?.session_type !== 'marketdata'
                ? params
                : {...params,sender_type: undefined,cg: undefined}),
            isPillarSource: true
        }
    }
});
